import { gql } from "@apollo/client";

// Reads via the standalone list query (not notificationSettings.installedBase):
// the federated settings path breaks for accounts with inconsistent setting
// containers, while this list stays reliable.
export const InstalledBaseNodeSubscriptions = gql`
    query InstalledBaseNodeSubscriptions {
        installedBaseNodeSubscriptionList {
            total
            subscriptions(pagination: { limit: 100, start: 0 }) {
                id
                inApp
                mail
                push
                iotAlert
                iotAlertSeverity
                maintenanceDue
                maintenanceSeverity
                maintenanceType
                insert
                update
                installedBaseNode {
                    id
                    title
                    nodeType {
                        key
                        name
                    }
                    pathNodes {
                        id
                        title
                    }
                }
            }
        }
    }
`;
